import React, { useState, useRef, useEffect } from "react";
import { getLotByAll } from "../../Model/Auction";
import NoImage from "../../images/resources/noImage.jpg";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import WITHDRAWN_IMAGE from "../../../images/Banner/withdrawn.jpg";
import { storeAllLots, getAllLots } from "../../../Model/LocalStorage";
import { getUser } from "../../Model/LocalStorage";

import { LotRailItem, LotListItem } from "./components/LotItems";
import { LotPreviewDialog } from "./components/LotDialogs";
import { FONT, R, thinScrollSx } from "./components/roomTheme";

/*
 * Lots rail (phones / tablets): horizontal list of the auction's lots, with a preview.
 *
 * UNCHANGED: loading the lots (getLotByAll + storeAllLots), the ordering (current lot
 * first), which lot is highlighted, and the auto-scroll.
 * Removed: the unused increment() / decrement() functions (and the loading overlay only
 * they could show), obsolete commented-out code and unused imports.
 */
export default function TitlebarBelowImageList({
  details,
  lotNumberNo,
  mediadQuery,
  fullList = false,
}) {
  const [getData, setGetData] = useState([]);
  const [count, setCount] = useState("");
  const [image, setImage] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [artist, setArtist] = React.useState("");
  const [lot_Number, setLotnumber] = React.useState("");
  const [, setStartingPrice] = React.useState("");
  const [hammer_price, setHammer_price] = React.useState("");
  const [statusLot, setStatus] = React.useState("");

  const [open, setOpen] = React.useState(false);
  const [loadingLots, setLoadingLots] = useState(false);
  const listContainerRef = useRef(null);
  const [withdrawn, setWithdrawn] = React.useState(0);
const itemRefs = useRef({});
const [userId, setUserId] = useState("");
const [userBid, setUserBid] = useState("");

  const handleClickOpen = (row,image) => {
    console.log(row)
    setUserBid(row.userBid)
    setWithdrawn(row.isWithdrawn)
    setImage(image);
    setTitle(row.title);
    setArtist(row.artist);
    setLotnumber(row.lot_number);
    setStartingPrice(row.starting_price);
    setHammer_price(row.hp);
    setStatus(row.lot_status);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const listImage = () => {
    const getNextAuction = async () => {
      try {
        setLoadingLots(true); // 🔁 Start loading
  
        const ArrayData = {
          auction_id: details?.auction_details?.auction_id,
          setId: details?.auction_details?.id,
          LotNo: lotNumberNo + 1,
        };
  
        const results = await getLotByAll(ArrayData);
  
        if (!results || results.success === false) {
          console.warn("Lot fetch failed.");
          setLoadingLots(false);
          return;
        }
  
        storeAllLots(results.msg);
        setGetData(results.msg);
      } catch (error) {
        console.error("getNextAuction error:", error);
      } finally {
        setLoadingLots(false); // ✅ End loading
      }
    };
  
    getNextAuction();
  };
  


  
  useEffect(() => {
    const getUserList = async () => {
      try {
        const user = await getUser();
        if (user) {
  
          setUserId(user.id);
    
        }
      } catch (err) {
        console.error("Failed to get user:", err);
      }
    };
    
    getUserList();

    setCount(lotNumberNo);
    const getLotsAll = async () => {
      try {
        const result = await getAllLots();

        if (!result || result === undefined || result === 'no record found') {
          listImage(); // fallback if no result
        } else {
          listImage(); // fallback if no result
        }
      } catch (error) {
        console.error("Error fetching lots:", error);
      }
    };
    getLotsAll();
    
  }, [getAllLots,lotNumberNo]);
  

  
  useEffect(() => {
    const targetLot = parseInt(count);
  
    if (loadingLots) return; // ⛔ Don't scroll while loading
  
    if (itemRefs.current[targetLot] && listContainerRef.current) {
      const container = listContainerRef.current;
      const item = itemRefs.current[targetLot];
  
      const containerLeft = container.getBoundingClientRect().left;
      const itemLeft = item.getBoundingClientRect().left;
  
      const scrollOffset = itemLeft - containerLeft;
  
      container.scrollTo({
        left: container.scrollLeft + scrollOffset,
        behavior: "smooth",
      });
    }
  }, [count, getData, loadingLots]);

  return (
    <>
      <Box
        ref={listContainerRef}
        component={fullList ? "ul" : "div"}
        role="list"
        sx={fullList ? {
          display: "flex",
          flexDirection: "column",
          gap: 0,
          m: 0,
          p: 0,
          listStyle: "none",
          width: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          ...thinScrollSx,
        } : {
          display: "flex",
          flexDirection: "row",
          overflowX: "auto",
          gap: 1,
          px: 1.5,
          py: 1.25,
          scrollBehavior: "smooth",
          scrollSnapType: "x proximity",
          ...thinScrollSx,
        }}
      >
        {Array.isArray(getData) && getData.length > 0 ? (
          [...getData]
            .sort((a, b) => {
              const aLot = a?.data;
              const bLot = b?.data;
              if (!aLot || !bLot) return 0;

              const aMatch = parseInt(aLot.lot_number) === count;
              const bMatch = parseInt(bLot.lot_number) === count;

              if (aMatch && !bMatch) return -1;
              if (!aMatch && bMatch) return 1;
              return 0;
            })
            .map((row, i) => {
              if (!row || !row.data) return null;

              const lot = row.data;
              const image = row.images?.[0]?.img_url || NoImage;

              const datat = parseInt(lot.lot_number) + 1;
              const datat1 = parseInt(count) + 2;

              const current = datat === datat1;
              const soldPrice = lot.lot_status === "SOLD"
                ? `₱ ${Number(lot.hp || 0).toLocaleString()}`
                : null;

              if (fullList) {
                return (
                  <LotListItem
                    key={lot.lot_id ?? i}
                    ref={(el) => {
                      if (el) itemRefs.current[parseInt(lot.lot_number)] = el;
                    }}
                    current={current}
                    onClick={() => handleClickOpen(lot, image)}
                    image={lot.isWithdrawn === 1 ? WITHDRAWN_IMAGE : image}
                    primaryHtml={`LOT ${lot.lot_number ?? ""}${lot.artist ? ` | ${lot.artist}` : ""}`}
                    secondaryHtml={lot.title ?? ""}
                    status={lot.lot_status}
                    soldPrice={soldPrice}
                    soldColor={lot.userBid === userId ? R.success : R.ink}
                  />
                );
              }

              return (
                <LotRailItem
                  key={lot.lot_id ?? i}
                  ref={(el) => {
                    if (el) itemRefs.current[parseInt(lot.lot_number)] = el;
                  }}
                  current={current}
                  onClick={() => handleClickOpen(lot, image)}
                  image={lot.isWithdrawn === 1 ? WITHDRAWN_IMAGE : image}
                  lotNumber={lot.lot_number}
                  title={lot.title ?? ""}
                  artist={lot.artist ?? ""}
                  status={lot.lot_status}
                  soldPrice={soldPrice}
                  soldColor={lot.userBid === userId ? R.success : R.ink}
                />
              );
            })
        ) : (
          <Typography sx={{ fontFamily: FONT, m: "auto", py: 3, color: R.secondary }}>
            Auction End
          </Typography>
        )}
      </Box>

      <LotPreviewDialog
        open={open}
        onClose={handleClose}
        image={withdrawn === 1 ? WITHDRAWN_IMAGE : image ?? NoImage}
        lotNumber={lot_Number}
        withdrawn={withdrawn}
        artist={artist}
        title={title}
        soldPrice={statusLot === "SOLD" ? `₱ ${Number(hammer_price || 0).toLocaleString()}` : null}
        soldColor={userBid === userId ? R.success : R.danger}
      />
    </>
  );
}
